import { useEffect, useState } from 'react'

export const useObjectUrl = (value?: File | string | null) => {
  const [objectUrl, setObjectUrl] = useState<string | null>(null)

  useEffect(() => {
    if (!value) {
      setObjectUrl(null)
      return
    }

    if (typeof value === 'string') {
      setObjectUrl(value)
      return
    }

    const url = URL.createObjectURL(value)
    setObjectUrl(url)

    return () => URL.revokeObjectURL(url)
  }, [value])

  return objectUrl
}
